import * as React from "react";
const SvgMinusIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 19, height: 19, viewBox: "0 0 19 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M18.026 9.83765L0.571486 9.83765", stroke: "currentColor", strokeWidth: 1.66234 }));
export default SvgMinusIcon;
